import Markdown from '@common/Node/CompletionChatbot/Markdown';
import styled from 'styled-components';

import { CircularProgress } from '@mui/material';
import { formatSEO } from '../FileSidebar';

const Container = styled.div`
  width: 100%;
  padding: 12px 24px;
  white-space: pre-wrap;
  word-break: break-word;

  ul,
  li {
    white-space: normal;
    color: ${({ theme }) => theme.text.standard};
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${({ theme }) => theme.text.standard};
    font-family: 'PPFormula';
  }

  h3 {
    font-size: 2ch;
    text-decoration: underline;
    font-size: 16px;
    font-weight: 600;
  }

  img {
    max-height: 200px;
    max-width: 500px;
  }

  p {
    font-family: 'Inter';
    color: ${({ theme }) => theme.text.standard};
  }

  a {
    color: ${({ theme }) => theme.theme === 'dark' ? theme.telnyx.green : theme.telBlue};
    text-decoration: underline;
    
    &:hover {
      opacity: 0.8;
    }
  }

  max-height: calc(100vh- 61px);
  overflow-y: auto;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`;

interface Props {
  file: string;
  isLoading: boolean;
}

export const TextFilePreview: React.FC<Props> = ({ file, isLoading }) => {
  const { body } = formatSEO(file);

  return (
    <Container>
      {isLoading && (
        <LoadingContainer>
          <CircularProgress size={30} thickness={3} />
        </LoadingContainer>
      )}
      {!isLoading && <Markdown content={body} />}
    </Container>
  );
};
